


import { Component, Prop, Vue } from 'vue-property-decorator';
import ResponsiveImage from '../utils/ResponsiveImage/index.vue';
import { HouseConfiguration, Media, MediaType } from '@/utils/api';
import LayeringEngine from '../LayeringEngine/index.vue';
import { Layer } from '../LayeringEngine/LayeringEngine.models';
import getOutsideLayers from '@/utils/helpers/getOutsideLayers';
import { presetMediaDimensions } from './PresetMedia.models';

@Component({
  components: {
    LayeringEngine,
    ResponsiveImage
  }
})
export default class PresetMedia extends Vue {
  @Prop({}) private configuration!: HouseConfiguration;
  @Prop({}) private media!: Media;

  private observer!: IntersectionObserver;
  private videoReference!: HTMLVideoElement;
  private isPlaying = false;

  private get layers(): Layer[] {
    return getOutsideLayers(this.configuration, presetMediaDimensions);
  }

  private get isMedia(): boolean {
    return !!this.media;
  }

  private get isVideo(): boolean {
    return this.isMedia && this.media.assetType === MediaType.VIDEO;
  }

  private changePlaying(newPlayValue: boolean): void {
    if (newPlayValue && !this.isPlaying) {
      this.videoReference?.play();
      this.isPlaying = newPlayValue;
    } else if (!newPlayValue && this.isPlaying) {
      this.videoReference?.pause();
      this.isPlaying = newPlayValue;
    }
  }

  private onVideoObserved(entries: IntersectionObserverEntry[]): void {
    entries.forEach((entry: IntersectionObserverEntry) => {
      this.changePlaying(entry.isIntersecting);
    });
  }

  mounted() {
    if (this.isVideo) {
      this.videoReference = this.$refs.video as HTMLVideoElement;
      this.observer = new IntersectionObserver(this.onVideoObserved);
      this.observer.observe(this.videoReference);
    }
  }
}
